import moment from "moment";
import _ from "lodash";
import { toast } from "react-toastify";

import API from "../../api";
import { formatResponse } from "../../formatResponses/reports";
import { usePetsReport } from "../../../store/reports/usePetsReport";

export default class PetsReportModel {
  setPetsReport = usePetsReport.getState().actions.setPetsReport;
  clearPetsReport = usePetsReport.getState().actions.clearPetsReport;
  setSummaryData = usePetsReport.getState().actions.setSummary;
  setLoading = usePetsReport.getState().actions.setLoading;
  setWaiting = usePetsReport.getState().actions.setWaiting;
  setFilterData = usePetsReport.getState().actions.setFilter;
  setSortData = usePetsReport.getState().actions.setSort;
  setPaginationPage = usePetsReport.getState().actions.setPaginationPage;

  constructor() {
    this.name = "reports-store-pets";
    this.setFilterData({
      dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD"),
    });
  }

  currentFilter() { return usePetsReport.getState().data.filter; }
  currentSort() { return usePetsReport.getState().data.sort; }
  setFilter(filterProps) { this.setFilterData(filterProps); }
  setSort(sortProps) { this.setSortData(sortProps); }

  async setPage(page) {
    const pageExists = usePetsReport.getState().data.petsReport[page];
    this.setPaginationPage(page);
    if (!pageExists) await this.getPetsReport();
  }

  async findPetsReport() {
    await this.getPetsReport();
  }

  async filterPetsReport() {
    this.setLoading(true);
    this.setPaginationPage(0);
    this.clearPetsReport();
    await this.getPetsReport();
    this.setLoading(false);
  }

  async getPetsReport() {
    try {
      this.setWaiting(true);

      const { data } = await API.get("reports/pets", { params: this.options() });
      const page = usePetsReport.getState().data.pagination.page;

      this.setPetsReport(
        formatResponse.petsReport(data?.results),
        formatResponse.listPagination(data?.pagination, page)
      );
      if (data?.panel) this.setSummaryData(formatResponse.petsPanel(data.panel));

      this.setWaiting(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.friendly_message ||
          error?.message ||
          "Não foi possível carregar o relatório de pets.",
        { theme: "colored" }
      );
      this.setWaiting(false);
      return null;
    }
  }

  async export() {
    try {
      await API.post("reports/export", {
        filters: this.filters(this.currentFilter()),
        type: { name: "pet", format: "xlxs" },
      });
      toast.success("Exportação iniciada. O arquivo aparece em Minhas Exportações.", { theme: "colored" });
    } catch (error) {
      toast.error(
        error?.response?.data?.friendly_message || error?.message || "Não foi possível exportar o relatório.",
        { theme: "colored" }
      );
    }
  }

  filters(filter) {
    return _.omitBy(
      {
        dateFrom: filter.dateFrom || undefined,
        dateTo: filter.dateTo || undefined,
        hasPackage: filter.hasPackage !== "*" ? filter.hasPackage : undefined,
        isSubscriber: filter.isSubscriber !== "*" ? filter.isSubscriber : undefined,
        minAbsenceDays: filter.minAbsenceDays !== "*" ? filter.minAbsenceDays : undefined,
        cpf: filter.cpf ? filter.cpf.replace(/\D/g, "") : undefined,
        search: filter.search || undefined,
      },
      _.isUndefined
    );
  }

  options() {
    const sort = usePetsReport.getState().data.sort;
    const pagination = usePetsReport.getState().data.pagination;

    return {
      currentePage: (pagination.page || 0) + 1,
      perPage: pagination.perPage || 50,
      sortBy: sort.sortBy,
      sortOrder: sort.sortOrder,
      ...this.filters(this.currentFilter()),
    };
  }
}
